import { bunja } from 'bunja';
import { atom } from 'jotai';

import { mapTable } from '..';
import { PswapOrder_fromJsonValue } from '../../../model/prex.v2.r230522.tables.private_orders';
import { r230522NormalSubSocketBunja } from '../../socket';
import { SubAccountIdScope } from '../../sub-account';

export const accountOrdersBunja = bunja(() => {
  const subAccountId = bunja.use(SubAccountIdScope);
  const { subscribe, tablesAtom } = bunja.use(r230522NormalSubSocketBunja);

  const orderTableAtom = atom((get) => {
    const tables = get(tablesAtom);
    const orders = tables['private/account-orders'] || {};
    return mapTable(orders, PswapOrder_fromJsonValue);
  });

  const ordersAtom = atom((get) => {
    const orderTable = get(orderTableAtom);
    return Object.entries(orderTable)
      .sort((a, b) => b[0].localeCompare(a[0]))
      .map(([, value]) => value);
  });

  bunja.effect(() => {
    if (subAccountId == null) return;
    return subscribe('private/account-orders', { rows: [`${subAccountId}/*`] });
  });

  return { ordersAtom };
});
accountOrdersBunja.debugLabel = 'accountOrdersBunja';
